module.exports = __webpack_public_path__ + "img/methoden_640.ea4d7332.webp";